import { getItems, createItem, itemUpdate, unitUpdate, deleteItem } from '../../api/items';

const state = {
    list: [],
    pageSize: 20,
    totalCount: 0
}

const getters = {
    getList( state ) {
       return state.list;
    }
}

const mutations = {
    PUSH_LIST(state, data) {
        state.list.push(data);
    },

    SET_LIST(state, data) {
       state.list = data;
    },

    SET_PARAMS(state, data){
        state.pageSize = data.perPage;
        state.totalCount = data.total;
    },

    UPDATE_LIST(state, data) {
        let item = state.list.find(item => item.uid === data.uid);
        
        if(!data.sku){
            item.description = data.item.description;
            item.slug = data.item.slug;
            item.title = data.item.title;
        }

        if(data.sku){
            let unit = item.storageUnits.find(item => item.sku_number === data.sku);
            unit.title = data.unit.title;
            unit.price = data.unit.price;
            unit.characteristics.volume = data.unit.characteristics.volume;
        }
    },

    DELETE_LIST(state, id) {
        let index = state.list.findIndex(item => item.id === id);
        state.list.splice(index, 1)
    },
}

const actions = {
    list({ dispatch, commit }, load) {
        let params = {
            pageSize: state.pageSize,
            page: 1
        }

        if(load && state.pageSize < state.totalCount){
            params.pageSize = state.pageSize + 20;
        }

        return new Promise( (resolve, reject) => {
            getItems(params).then(res => {

                if(res.data){
                    commit('SET_LIST', res.data.dataProvider.items);
                    commit('SET_PARAMS', { perPage: parseInt(res.data.dataProvider._meta.perPage), total: parseInt(res.data.dataProvider._meta.totalCount) });

                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });

                reject(error);
            });
        })
    },

    remove({ dispatch, commit }, id) {
        return new Promise( (resolve, reject) => {
            deleteItem(id).then(res => {
                if(res){
                    commit('DELETE_LIST', id);
                    dispatch('Common/setSuccess', 'Item deleted', { root: true });
                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });

                reject(error);
            });
        })
    },

    new({ dispatch, commit }, data) {
        return new Promise( (resolve, reject) => {
            console.log(data);

            let bodyFormData = new FormData();

            bodyFormData.append('Item[title]', data.title);
            bodyFormData.append('Item[slug]', data.slug);
            bodyFormData.append('Item[description]', data.description);
            bodyFormData.append('Unit[title]', data.unitTitle);
            bodyFormData.append('Unit[number]', data.unitNumber);
            bodyFormData.append('Unit[price]', data.unitPrice);
            bodyFormData.append('Unit[preview]', data.unitPreview);
            bodyFormData.append('Unit[characteristics][weight]', data.unitWeight);
            bodyFormData.append('Unit[type]', 'Default');

            createItem(bodyFormData).then(res => {
                dispatch('Common/setSuccess', 'Product created', { root: true });
                dispatch('list');
                resolve();

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });
                dispatch('list');
                reject(error);
            });
        })
    },

    update({ dispatch, commit }, data) {
        return new Promise( (resolve, reject) => {
            updaeItem(data.id, data).then(res => {
                if(res.data){
                    commit('UPDATE_LIST', {item: res.data} );
                    dispatch('Common/setSuccess', 'Item updated', { root: true });

                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });

                reject(error);
            });
        })
    },

    updateUnit({ dispatch, commit }, data) {
        return new Promise( (resolve, reject) => {
            unitUpdate(data.id, data.data).then(res => {
                if(res.data){
                    commit('UPDATE_LIST', {sku: res.data.form.sku, uid: data.uid, unit: res.data.form.unit });
                    dispatch('Common/setSuccess', 'Unit updated', { root: true });

                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });

                reject(error);
            });
        })
    },

    updateItem({ dispatch, commit }, data) {
        return new Promise( (resolve, reject) => {
            itemUpdate(data.id, data.data).then(res => {
                
                if(res.data){
                    commit('UPDATE_LIST', {uid: data.uid || res.data.form.uid, item: res.data.form.item });
                    dispatch('Common/setSuccess', 'Item updated', { root: true });

                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });

                reject(error);
            });
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}